// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h-splitter[data-v-54217166]{position:absolute;left:0;height:5px;margin-top:-2px;width:100%;z-index:1;opacity:0;pointer-events:all}.h-splitter[data-v-54217166]:hover{cursor:row-resize;opacity:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
